import {motion, AnimatePresence} from 'framer-motion';

// Hooks

import ReactDOM from 'react-dom';
import {useScrollFreeze} from '../../hooks/useScrollFreeze';

const ModalInner = ({children, ...props}: any) => {
  useScrollFreeze();
  return (
    <motion.div
      {...props}
      className="bg-tintorange fixed left-0 top-0 z-[999] h-screen w-screen overflow-y-auto"
    >
      {children}
    </motion.div>
  );
};

const isClient = typeof document !== `undefined`;

export const StandardModal = ({isOpen, children}: any) =>
  isClient
    ? ReactDOM.createPortal(
        <AnimatePresence>
          {isOpen && (
            <ModalInner
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              transition={{type: 'spring', damping: 10}}
            >
              {children}
            </ModalInner>
          )}
        </AnimatePresence>,
        document.body,
      )
    : null;
